import "bootstrap/dist/css/bootstrap.min.css";
import * as OFMSUI from "react-bootstrap";
// import { Formik, Field } from "formik";
import { useFormik, FormikProvider, Field } from "formik";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Form } from "react-bootstrap";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import HousingService from "../../../Services/HousingService";
import * as Yup from "yup";
import { FaEye, FaFastBackward } from "react-icons/fa";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import jsPDF from "jspdf";
import { store } from "../../../App";
import Select from "react-select";
import { generateConsultantPayslip, generateNMRPayslip, generateRegularPayslip, GetDetails, LabelHeader, ModuleHeader } from "../../utils/commonFunctions";
import "jspdf-autotable";

function EmployeePayParticulars() {
  const [EmpTypeList, setEmpTypeList] = useState()
  const [monthlist, setmonthlist] = useState()
  const [yearlist, setyearlist] = useState([])
  const [empnamelist, setempnamelist] = useState([])
  const [Show, setShow] = useState(false)
  const [empPay, setEmpPay] = useState([])
  // const [distList, setDistList] = useState()
  // const [distData, setDistData] = useState([])
  const [employeename, setemployeename] = useState([])
  const [displayempname, setdispname] = useState([])
  const [tomonthData, settomonthData] = useState([])
  const [tomonthname, settomonthname] = useState([])
  const [frommonthname, setfrommonthname] = useState([])
  const [emptype_id, setEmptype_id] = useState('')
  // const [toyearData, settoyearData] = useState([])
  const [toyearname, settoyearname] = useState([])
  const [onclicktable, setonclicktable] = useState(false)
  const [detailedPayParticulars, setDetailedPayParticulars] = useState([])
  const [saveEmpType, setSaveEmpType] = useState("")
  const [displayEmpType, setDisplayEmpType] = useState("");
  const [empTypeRes, setEmpTypeRes] = useState([]);
  const [selectedEmpId, setSelectedEmpId] = useState("");
  // const [displayDistrict, setDisplayDistrict] = useState("");
  const [designation, setDesignation] = useState("")
  const [distListt, setDistListt] = useState([]);

  const [regData, setRegData] = useState([]);
  const [nmrData, setNmrData] = useState([]);
  const [conData, setConData] = useState([]);


  const [regDataTable, setRegDataTable] = useState(false);
  const [nmrDataTable, setNmrDataTable] = useState(false);
  const [conDataTable, setConDataTable] = useState(false);

  const handleClose = () => {
    setonclicktable(false)
    setShow(true)
  }
  const handleViewDetailedPayParticulars = (emp_id, emp_type, fromYear, toYear, fromMonth, toMonth, payment_type,
    // district
  ) => {
    const values = {
      emp_id: emp_id, emp_type: emp_type, fromYear: fromYear, toYear: toYear, fromMonth: fromMonth, toMonth: toMonth, payment_type: payment_type
      // district: district 
    }
    store.dispatch({ type: 'SHOW_SPINNER' })
    HousingService.getEmp_paypdf(values).then(res => {
      const result = res.data[0];
      if (result?.data1?.length > 0) {
        setRegDataTable(true);
      } else {
        setRegDataTable(false);
      }

      if (result?.data2?.length > 0) {
        setNmrDataTable(true);
      } else {
        setNmrDataTable(false);
      }

      if (result?.data3?.length > 0) {
        setConDataTable(true);
      } else {
        setConDataTable(false);
      }

      setRegData(result?.data1 ?? []);
      setNmrData(result?.data2 ?? []);
      setConData(result?.data3 ?? []);
    }).finally(() => {
      store.dispatch({ type: 'HIDE_SPINNER' });
      setonclicktable(true);
      setShow(false);
    })
  }

  // const history = useHistory()
  React.useEffect(() => {
    HousingService.CGG_District().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => { return (<option key={i} value={item.code}> {item.name} </option>); }); setDistListt(options);
      }
    });
    HousingService.fetchEmptypeList().then(res => {
      if (res.data) {
        setEmpTypeRes(res.data);
        console.log(res.data);
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.emptype_id}>
              {item.emptype_name}
            </option>
          )
        })

        setEmpTypeList(options)
      }
    })
    HousingService.fetchMonthList().then(res => {
      if (res.data) {
        settomonthData(res.data)
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.month_id}>
              {item.month_name}
            </option>
          )
        })

        setmonthlist(options)
      }
    })
    HousingService.fetchYearList().then(res => {
      if (res.data) {
        setyearlist(res.data);
      }
    })
  }, [])

  // const empname = e => {
  //   if (e.target.value != "") {
  //     let params = { emp_type: formik.values.emp_type, district: e.target.value };
  //     HousingService.getEmpNamesbyTypeandDistrict(params).then(res => {
  //       if (res.data) {
  //         setemployeename(res.data);
  //         let options = res.data.map((item, i) => ({ value: item.emp_id, label: item.emp_name }));
  //         setempnamelist([{ value: "", label: "Select" }, ...options]);
  //       }
  //     })
  //   }
  //   else { setemployeename(""); setempnamelist([]); }
  // }

  const empname = (e) => {
    if (e.target.value !== "") {

      const params = {
        emp_type: formik.values.emp_type,
        district: e.target.value
      };

      HousingService.getEmpNamesbyTypeandDistrict(params).then((res) => {

        const data = res.data || [];

        setemployeename(data);

        const options = data.map((item) => ({
          value: item.emp_id,
          label: item.emp_name
        }));

        setempnamelist([
          { value: "", label: "Select" },
          ...options
        ]);
      });

    } else {

      setemployeename([]);
      setempnamelist([]);

    }
  };

  const handleBack = () => {
    setonclicktable(false);
    setShow(true);
    setNmrDataTable(false);
    setRegDataTable(false);
    setConDataTable(false);
  };


  function GeneratePDF() {
    const pageWidth = 210 // Example: 210mm for A4 size
    const pageHeight = 297 // Example: 297mm for A4 size
    const imgPath = '/img/APSHCL_logo.png'
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: [pageWidth, pageHeight]
    })
    const EmployeeeName = displayempname
    const toYearNamee = toyearname
    const toMonthNamee = tomonthname

    const headingText2 =
      'Andhra Pradesh State Housing Corporation Limited (APSHCL)' // New heading text (displayed first)
    const headingText3 = `Employee pay particulars of ${EmployeeeName} till: ${toMonthNamee} ${toYearNamee}` // New heading text (displayed second)
    const headingText4 =
      'Nirman Bhavan, Plot No 11 & 12, Auto Nagar, Vijayawada, AP-520007'

    const fontSize = 12 // Reduce font size to 10 points

    const textWidth4 =
      (doc.getStringUnitWidth(headingText4) * fontSize) /
      doc.internal.scaleFactor
    const xCoordinate4 = (pageWidth * 1.5 - textWidth4) / 2

    doc.setFont('times new roman')

    const textWidth2 =
      (doc.getStringUnitWidth(headingText2) * fontSize) /
      doc.internal.scaleFactor

    const textWidth3 =
      (doc.getStringUnitWidth(headingText3) * fontSize) /
      doc.internal.scaleFactor

    const tableYStart = 35 // You can adjust this value to control the space between text and the table

    doc.setFontSize(fontSize)

    const xCoordinate2 = (pageWidth * 1.5 - textWidth2) / 2

    doc.text(headingText2, xCoordinate2, 10) // Adjust the Y-coordinate as needed

    const xCoordinate3 = (pageWidth * 1.5 - textWidth3) / 2

    doc.text(headingText3, xCoordinate3, 30) // Adjust the Y-coordinate as needed
    doc.text(headingText4, xCoordinate4, 20) // Adjust the Y-coordinate (e.g., 20) as needed

    doc.addImage(imgPath, 'PNG', 5, 5, 25, 25) // Adjust the size as needed

    doc.autoTable({
      html: '#my-table',
      theme: 'grid',
      tableWidth: 'auto',
      columnStyles: {
        3: { cellWidth: 'wrap' }
      },
      startY: tableYStart,
      margin: { top: 5, right: 15, bottom: 5, left: 15 }, // Decrease cell padding to 5 mm
      styles: {
        fontSize: 8 // Reduce font size for table data to 8 points
      },
      columnWidth: { 0: 20, 1: 30, 2: 40 } // Adjust column widths as needed
    })

    doc.save('Emppay.pdf')
  }
  function GenerateOnclickPDF(tableId) {
    const pageWidth = 500; // Example: 210mm for A4 size
    const pageHeight = 297; // Example: 297mm for A4 size
    const imgPath = '/img/APSHCL_logo.png';
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: [pageWidth, pageHeight],
    });
    const EmployeeeName = displayempname;
    const toYearNamee = toyearname;
    const toMonthNamee = tomonthname;

    const headingText2 = 'Andhra Pradesh State Housing Corporation Limited (APSHCL)';
    const headingText3 = `Employee pay particulars of ${EmployeeeName} till: ${toMonthNamee} ${toYearNamee}`;
    const headingText4 = 'Nirman Bhavan, Plot No 11 & 12, Auto Nagar, Vijayawada, AP-520007';

    const fontSize = 14; // Font size for headings
    doc.setFont('times', 'normal'); // Set font to Times New Roman

    // Calculate X-coordinates for centering each heading
    const xCoordinate2 = (pageWidth - doc.getTextWidth(headingText2)) / 2;
    const xCoordinate3 = (pageWidth - doc.getTextWidth(headingText3)) / 2;
    const xCoordinate4 = (pageWidth - doc.getTextWidth(headingText4)) / 2;

    const tableYStart = 45; // Adjusted space between headings and the table

    doc.setFontSize(fontSize);
    doc.text(headingText2, xCoordinate2, 20); // Centered on the page
    doc.text(headingText4, xCoordinate4, 30); // Centered on the page
    doc.text(headingText3, xCoordinate3, 40); // Centered on the page

    doc.addImage(imgPath, 'PNG', 5, 5, 25, 25); // Adjust the size as needed

    doc.autoTable({
      html: `#${tableId}`,
      theme: 'striped',
      tableWidth: 'auto',
      columnStyles: {
        3: { cellWidth: 'wrap' },
      },
      startY: tableYStart,
      margin: { top: 5, right: 15, bottom: 5, left: 15 },
      styles: {
        fontSize: 8, // Reduce font size for table data
      },
      columnWidth: { 0: 5, 1: 5, 2: 5 }, // Adjust column widths as needed
    });

    doc.save('Emppay.pdf');
  }

  const handleEmpChange = option => {
    setSelectedEmpId(option.value)
  }
  const formik = useFormik({
    initialValues: {
      emp_id: '',
      district: '',
      emp_type: '',
      fromYear: '',
      fromMonth: '',
      toYear: '',
      toMonth: '',
      payment_type: 'All'
    },

    validationSchema: Yup.object({
      emp_id: Yup.string().required('Employee ID is required'),
      district: Yup.string().required('District is required'),
      emp_type: Yup.string().required('Employee type is required'),
      fromYear: Yup.string().required('From year is required'),
      fromMonth: Yup.string().required('From month is required'),
      toYear: Yup.string().required('To year is required'),
      toMonth: Yup.string().required('To month is required')
    }),
    onSubmit: values => {
      // let dist = distData.find((item) => item.code == values.district)
      // setDisplayDistrict(dist?.name)
      // console.log("dist?.name:", dist?.name)
      console.log(values.emp_id, values.emp_type);
      setSaveEmpType(values.emp_type);
      let empTypevalue = empTypeRes.filter(item => item.emptype_id == formik.values.emp_type).map(item => item.emptype_name);
      setDisplayEmpType(empTypevalue);
      console.log("empTypevalue:", empTypevalue)
      let EmpValue = employeename.filter(item => item.emp_id === formik.values.emp_id).map(item => item.emp_name);
      setdispname(EmpValue)
      let fromMonthvalue = tomonthData
        .filter(item => item.month_id === formik.values.fromMonth)
        .map(item => item.month_name)
      setfrommonthname(fromMonthvalue)

      let tomonthValue = tomonthData
        .filter(item => item.month_id === formik.values.toMonth)
        .map(item => item.month_name)
      settomonthname(tomonthValue)

      let toyearValue = formik.values.toYear
      settoyearname(toyearValue)
      store.dispatch({ type: 'SHOW_SPINNER' })
      HousingService.getEmployeePayParticularsReport(formik.values).then(response => {
        if (response && response.data && response.data?.length > 0) {
          // setEmpPay(response.data);
          const sortedData = [...response.data].sort((a, b) => {
            // Sort by year
            const yearDiff = Number(a.year) - Number(b.year);
            if (yearDiff !== 0) return yearDiff;

            // If year is same, sort by month
            return Number(a.confirm_month) - Number(b.confirm_month);
          });

          setEmpPay(sortedData);
          setDesignation(response.data?.[0]?.designation_name);
        }
        else { setEmpPay([]); setDesignation(""); }
      }).finally(() => {
        store.dispatch({ type: 'HIDE_SPINNER' });
        setonclicktable(false);
        setShow(true);
      })
    }
  })
  // const toYearList = yearlist.filter(y => !formik.values.fromYear || y.year >= formik.values.fromYear)
  //   .map((item, i) => (
  //     <option key={i} value={item.year}>
  //       {item.year}
  //     </option>
  //   ));

  const handlePdf = (emp_id, payment_type, year, confirm_month) => {
    const normalizedType = payment_type.toLowerCase().includes("reg") ? "reg" : "supp";
    const values = { emp_id: emp_id, payment_type: normalizedType, year: year, confirm_month: confirm_month };
    HousingService.emp_pay_particulars_pdf(values).then((res) => { const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" })); let tab = window.open(); tab.location.href = url; });
  };

  const handleChangeEmpType = (e) => {
    const value = e.target.value;
    formik.handleChange(e);
    setEmptype_id(value);
    formik.setFieldValue("district", "");
    formik.setFieldValue("emp_id", "");
    setSelectedEmpId("");
    setemployeename([]);
    setempnamelist([]);
  };
  return (
    <>
      <NavigationServicesHeader />

      <>

        <ModuleHeader title="Employee Pay Particulars" />
        <OFMSUI.Container className='outer-page-content-container' fluid style={{ width: "90%" }}>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <OFMSUI.Row className='p-2 '>
                <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className='mb-3' >
                  <LabelHeader title="Employee Type" />
                  {/* <Field
                    component='select'
                    name='emp_type'
                    className={formik.touched.emp_type && formik.errors.emp_type ? 'form-control is-invalid' : 'form-control'}
                    onChange={e => { setEmptype_id(e.target.value); formik.handleChange(e); formik.setFieldValue("emp_id", ""); setSelectedEmpId(""); setemployeename(""); setempnamelist([]); }}
                    onChange={handleChangeEmpType}
                  // onChange={e => { setEmptype_id(e.target.value); formik.handleChange(e); formik.setFieldValue("emp_id", ""); setSelectedEmpId(""); setemployeename(""); empname(e); }}
                  > */}
                  <Field
                    component='select'
                    name='emp_type'
                    className={
                      formik.touched.emp_type && formik.errors.emp_type
                        ? 'form-control is-invalid'
                        : 'form-control'
                    }
                    onChange={handleChangeEmpType}
                  >
                    <option value='select'>Select</option>
                    {EmpTypeList}
                  </Field>
                  {formik.touched.emp_type && formik.errors.emp_type ? (<div className='invalid-feedback'> {formik.errors.emp_type} </div>) : null}
                </OFMSUI.Col>
                <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                  <LabelHeader title="District" />
                  <Field
                    component='select'
                    name='district'
                    className={formik.touched.district && formik.errors.district ? 'form-control is-invalid' : 'form-control'}
                    // onChange={e => { empname(e); formik.handleChange(e); formik.setFieldValue("emp_id", ""); setSelectedEmpId(""); }}
                    onChange={(e) => { formik.handleChange(e); formik.setFieldValue("emp_id", ""); setSelectedEmpId(""); empname(e); }}
                  >
                    <option value=''>Select</option>
                    {distListt}
                  </Field>
                  {formik.touched.district && formik.errors.district ? (<div className='invalid-feedback'> {formik.errors.district} </div>) : null}
                </OFMSUI.Col>

                <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-3' >
                  <LabelHeader title="Employee Name" />

                  <Field
                    render={({ field, form }) => (
                      <Select
                        name='emp_id'
                        {...field} options={[{ value: 'ALL', label: '---Select---' }, ...empnamelist]}
                        isSearchable
                        className={formik.touched.emp_id && formik.errors.emp_id ? 'form-control is-invalid' : 'form-control'}
                        onChange={option => { form.setFieldValue('emp_id', option.value); handleEmpChange(option) }}
                        // value={empnamelist?.length > 0 && empnamelist?.find((option) => option.value === selectedEmpId)}
                        value={ empnamelist.find(option => option.value === selectedEmpId) || null }
                      />
                    )}
                  />
                  {formik.touched.emp_id && formik.errors.emp_id ? (<div className='invalid-feedback'> {formik.errors.emp_id} </div>) : null}
                </OFMSUI.Col>


                <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className='mb-3' >
                  <LabelHeader title="From Month" />

                  <Field
                    component='select' name='fromMonth'
                    className={formik.touched.fromMonth && formik.errors.fromMonth ? 'form-control is-invalid' : 'form-control'}
                  >
                    <option value=''>Select</option>
                    {monthlist}
                  </Field>
                  {formik.touched.fromMonth && formik.errors.fromMonth ? (<div className='invalid-feedback'> {formik.errors.fromMonth} </div>) : null}
                </OFMSUI.Col>
                <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className='mb-3' >
                  <LabelHeader title="From Year" />
                  <Field
                    component='select' name='fromYear' className={formik.touched.fromYear && formik.errors.fromYear ? 'form-control is-invalid' : 'form-control'}
                    onChange={(e) => { formik.handleChange(e); formik.setFieldValue("toYear", "") }}
                  >
                    <option value=''>Select</option>
                    {yearlist?.map((item, i) => (
                      <option key={i} value={item.year}>{item.year}</option>
                    ))}
                  </Field>
                  {formik.touched.fromYear && formik.errors.fromYear ? (<div className='invalid-feedback'> {formik.errors.fromYear} </div>) : null}
                </OFMSUI.Col>

                <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className='' >
                  <LabelHeader title="To Month" />

                  <Field
                    component='select'
                    name='toMonth'
                    className={formik.touched.toMonth && formik.errors.toMonth ? 'form-control is-invalid' : 'form-control'}
                  >
                    <option value=''>Select</option>
                    {monthlist}
                  </Field>
                  {formik.touched.toMonth && formik.errors.toMonth ? (<div className='invalid-feedback'> {formik.errors.toMonth} </div>) : null}
                </OFMSUI.Col>
                <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className='' >
                  <LabelHeader title="To Year" />
                  <Field
                    component='select'
                    name='toYear'
                    className={formik.touched.toYear && formik.errors.toYear ? 'form-control is-invalid' : 'form-control'}
                    min={formik.values.fromYear}
                  >
                    <option value=''>Select</option>
                    {yearlist?.filter(item => !formik.values.fromYear || item.year >= formik.values.fromYear
                    ).map((item, i) => (
                      <option key={i} value={item.year}>{item.year}</option>
                    ))
                    }
                  </Field>
                  {formik.touched.toYear && formik.errors.toYear ? (<div className='invalid-feedback'> {formik.errors.toYear} </div>) : null}
                </OFMSUI.Col>
                <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className='' >
                  <LabelHeader title="Payment Type" />
                  <Field
                    component='select'
                    name='payment_type'
                    value={formik.values.payment_type}
                    onChange={e => formik.setFieldValue('payment_type', e.target.value)}
                    className={formik.touched.payment_type && formik.errors.payment_type ? 'form-control is-invalid' : 'form-control'}
                  >
                    <option value='All'>ALL</option>
                    <option value='reg'>Regular</option>
                    <option value='supp'>Supplementary</option>
                  </Field>
                  {formik.touched.payment_type && formik.errors.payment_type ? (<div className='invalid-feedback'> {formik.errors.payment_type} </div>) : null}
                </OFMSUI.Col>
                {/* <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='' > <button type='submit' className='btn btn-success btn-sm' style={{ marginLeft: '30px' }} > Get Details </button> </OFMSUI.Col> */}
                <GetDetails />
              </OFMSUI.Row>

              {Show && (
                <Form>

                  <OFMSUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className=' mb-2 float-end' >
                    <button type='button' className='btn btn-success btn-sm' style={{ float: 'right', color: '#fff', fontSize: '12px' }} > <ReactHTMLTableToExcel id='test-table-xls-button' className='download-table-xls-button' table='my-table' filename='Emppay' sheet='tablexls' buttonText='Excel' ></ReactHTMLTableToExcel> </button>
                    <button type='button' className='btn btn-danger btn-sm' onClick={GeneratePDF} style={{ float: 'right', marginLeft: '3px', fontSize: '12px' }} > PDF <MdOutlinePictureAsPdf /> </button>
                  </OFMSUI.Col>
                  <OFMSUI.Row>
                    <OFMSUI.Table striped bordered hover id='my-table'>
                      <thead className='fw-bold' style={{ position: 'sticky', top: '0px' }} >
                        <tr className='table_countshead'> <td colSpan={10} style={{ textAlign: 'center' }}> {' '} Employee Pay Particulars of {displayempname}-{(formik.values.emp_id)} from {frommonthname}-{formik.values.fromYear} to{' '} {tomonthname}-{formik.values.toYear} </td>{' '} </tr>
                        <tr className='table_countshead'>
                          <th>S No.</th>
                          <th>Year</th>
                          <th>Month</th>
                          <th>Payment Type</th>
                          <th>Earnings(in Rs/-)</th>
                          <th>Deductions(in Rs/-)</th>
                          {(saveEmpType == 1 || saveEmpType == 2 || saveEmpType == 5) && (<th>Loan(in Rs/-)</th>)}
                          <th colSpan={2}>Net Salary(in Rs/-)</th>
                          <th style={{ textAlign: "center" }}>View Pay Slip</th>
                        </tr>
                      </thead>
                      <tbody>
                        {empPay.length === 0 ? (<tr> <td colSpan={9} style={{ textAlign: 'center' }}> No data available </td> </tr>) : (empPay.map((item, index) => (
                          <tr key={index}>
                            <td style={{ textAlign: 'center', width: '60px' }} > {index + 1} </td>
                            <td>{item.year}</td>
                            <td>{item.month_name}</td>
                            {(saveEmpType == 1 || saveEmpType == 2 || saveEmpType == 5) && (<><td>{
                              item.payment_type === "reg"
                                ? "Regular"
                                : item.payment_type === "supp"
                                  ? "Supplementary"
                                  : item.payment_type
                            }</td><td className='sum'>{item.earnings || 0}</td>
                              <td className='sum'>{item.deductions || 0}</td></>)}
                            {(saveEmpType == 3 || saveEmpType == 4) && (<><td> {item.payment_type} </td><td>{item.earnings || 0}</td><td>{item.deductions || 0}</td></>)}
                            {(saveEmpType == 1 || saveEmpType == 2 || saveEmpType == 5) && (<><td className='sum'>{item.loan || 0}</td><td className='sum' colSpan={2}>
                              {(item.earnings ?? 0) - (item.deductions ?? 0) - (item.loan ?? 0)}
                            </td>
                            </>)}
                            {(saveEmpType == 3 || saveEmpType == 4) && (<> <td className='sum' colSpan={2}>
                              {(item.earnings ?? 0) - (item.deductions ?? 0)}
                            </td>
                            </>
                            )}
                            <td><div style={{ textAlign: "center", color: "green" }} > <FaEye onClick={() => handlePdf(formik.values.emp_id, item.payment_type, item.year, item.confirm_month)} /> </div></td>
                          </tr>
                        ))
                        )}
                      </tbody>
                      <tfoot>
                        <tr className='table_countshead'>
                          <td colSpan={7} className="text-end"> </td>
                          {/* {(saveEmpType == 1 || saveEmpType == 2 || saveEmpType == 5) && (<> <td> {' '} {empPay.reduce((total, item) => total + item.earnings, 0)} </td>
                            <td> {' '} {empPay.reduce((total, item) => total + item.deductions, 0)} </td><td> {' '} {empPay.reduce((total, item) => total + item.loan, 0)} </td>
                            <td> {empPay.reduce((total, item) => total + item.earnings - item.deductions - item.loan, 0)} </td></>)}
                          {(saveEmpType == 3 || saveEmpType == 4) && (<>  <td> {' '} {empPay.reduce((total, item) => total + item.total_earnings, 0)} </td>
                            <td> {' '} {empPay.reduce((total, item) => total + item.total_deductions, 0)} </td><td className='sum'> {empPay.reduce((total, item) => total + item.total_earnings - item.total_deductions, 0)} </td></>)} */}

                          <td style={{ textAlign: "center" }} colSpan={4}> <button type='button' className='btn btn-link btn-sm' style={{ background: 'white' }} onClick={() => handleViewDetailedPayParticulars(formik.values.emp_id, formik.values.emp_type, formik.values.fromYear, formik.values.toYear, formik.values.fromMonth, formik.values.toMonth, formik.values.payment_type
                            // formik.values.district
                          )} > View Detailed PayParticular </button> </td>
                        </tr>
                      </tfoot>
                    </OFMSUI.Table>
                  </OFMSUI.Row>

                </Form>
              )}
            </Form>

            {onclicktable && (
              <div style={{ overflowX: 'auto' }}>
                <OFMSUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className=' mb-2 float-end' >
                  <button className='btn btn-primary btn-sm' type='reset' onClick={handleBack} style={{ float: 'right', marginLeft: '10px' }} > Back </button>
                </OFMSUI.Col>
                <center><h6>ANDHRA PRADESH STATE HOUSING CORPN. LTD.</h6></center>
                <center> <h6>  Detailed Pay-Particular of {displayempname}-{(formik.values.emp_id)} from {frommonthname}- {formik.values.fromYear} to {tomonthname}- {formik.values.toYear} </h6> </center>


                {nmrDataTable && (<>
                  <div style={{ overflowX: 'auto' }}>
                    <OFMSUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className=' mb-2 float-end' >
                      <button type='button' className='btn btn-success btn-sm' style={{ float: 'right', color: '#fff' }} >
                        <ReactHTMLTableToExcel
                          id='test-table-xls-button'
                          className='download-table-xls-button'
                          table='my-table1'
                          filename='EmployeePay'
                          sheet='tablexls'
                          buttonText='Excel'
                        ></ReactHTMLTableToExcel>
                      </button>
                      <button type='button' className='btn btn-danger btn-sm'
                        onClick={() => GenerateOnclickPDF('my-table1')}
                        style={{ float: 'right', marginLeft: '3px' }} > PDF <MdOutlinePictureAsPdf /> </button>
                    </OFMSUI.Col>
                  </div>
                  <center><h6 style={{ color: "blue" }}>Employee Type : NMR</h6></center>
                  <OFMSUI.Table striped bordered hover id='my-table1'>
                    <thead className='fw-bold' style={{ position: 'sticky', top: '0px' }}>
                      <tr style={{ textAlign: "right" }}>
                        <th style={{ textAlign: "right" }}>S No.</th>
                        <th style={{ textAlign: "right" }}>Month</th>
                        <th style={{ textAlign: "right" }}>Year</th>
                        <th style={{ textAlign: "right" }}>Payment Type</th>
                        <th style={{ textAlign: "right" }}>Gross Earnings</th>
                        <th style={{ textAlign: "right" }}>FA Deductions</th>
                        <th style={{ textAlign: "right" }}>EES EPF Deductions</th>
                        <th style={{ textAlign: "right" }}>Postal Rd Deductions</th>
                        <th style={{ textAlign: "right" }}>Professional Tax Deductions</th>
                        <th style={{ textAlign: "right" }}>Other Deductions</th>
                        <th style={{ textAlign: "right" }}>EA Deductions</th>
                        <th style={{ textAlign: "right" }}>MA Deductions</th>
                        <th style={{ textAlign: "right" }}>LIC Deductions</th>
                        <th style={{ textAlign: "right" }}>TDS Deductions</th>
                        <th style={{ textAlign: "right" }}>Total Deductions</th>
                        <th style={{ textAlign: "right" }}>Total Earnings</th>
                        <th style={{ textAlign: "right" }}>Net Salary</th>
                        {/* <th style={{ textAlign: "center" }}>View Pay Slip</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {nmrData && nmrData.length > 0 ? (
                        nmrData.map((item, i) => (
                          <tr key={i} style={{ textAlign: "right" }}>
                            <td>{i + 1}</td>
                            <td>{item.month_name}</td>
                            <td>{item.year}</td>
                            <td>{item.payment_type}</td>
                            <td>{item.nmr_gross_earnings}</td>
                            <td>{item.nmr_fa_deductions}</td>
                            <td>{item.os_ees_epf_deductions}</td>
                            <td>{item.nmr_postalrd_deductions}</td>
                            <td>{item.os_prof_tax_deductions}</td>
                            <td>{item.nmr_otherliab_deductions}</td>
                            <td>{item.nmr_ea_deductions}</td>
                            <td>{item.nmr_ma_deductions}</td>
                            <td>{item.nmr_lic_deductions}</td>
                            <td>{item.nmr_tds_deductions}</td>
                            <td style={{ color: "red" }}>{item.total_deductions}</td>
                            <td style={{ color: "green" }}>{item.total_earnings}</td>
                            <td style={{ color: "darkblue" }}>
                              {item.total_earnings - item.total_deductions}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="18" style={{ textAlign: "center" }}>No data available</td>
                        </tr>
                      )}
                    </tbody>
                  </OFMSUI.Table>
                </>)}
                {conDataTable && (<>
                  <div style={{ overflowX: 'auto' }}>
                    <OFMSUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className=' mb-2 float-end' >
                      <button type='button' className='btn btn-success btn-sm' style={{ float: 'right', color: '#fff' }} >
                        <ReactHTMLTableToExcel
                          id='test-table-xls-button'
                          className='download-table-xls-button'
                          table='my-table2'
                          filename='EmployeePay'
                          sheet='tablexls'
                          buttonText='Excel'
                        ></ReactHTMLTableToExcel>
                      </button>
                      <button type='button' className='btn btn-danger btn-sm' onClick={() => GenerateOnclickPDF('my-table2')} style={{ float: 'right', marginLeft: '3px' }} > PDF <MdOutlinePictureAsPdf /> </button>
                    </OFMSUI.Col>
                  </div>
                  <center><h6 style={{ color: "orange" }}>Employee Type : Consultant</h6></center>
                  <OFMSUI.Table striped bordered hover id='my-table2'>
                    <thead className='fw-bold' style={{ position: 'sticky', top: '0px' }}>
                      <tr style={{ textAlign: "right" }}>
                        <th style={{ textAlign: "right" }}>S No.</th>
                        <th style={{ textAlign: "right" }}>Month</th>
                        <th style={{ textAlign: "right" }}>Year</th>
                        <th>Payment Type</th>
                        <th>Basic Pay Earnings</th>
                        <th>CA Earnings</th>
                        <th>EC EPF</th>
                        <th>Performance Earnings</th>
                        <th>HRA Earnings</th>
                        <th>Medical Earnings</th>
                        <th>EES EPF Deductions</th>
                        <th>ERS EPF Deductions</th>
                        <th>Professional Tax Deductions</th>
                        <th>Other Deductions</th>
                        <th>Total Deductions</th>
                        <th>Total Earnings</th>
                        <th>Net Salary</th>
                        {/* <th>View Pay slip</th> */}

                      </tr>
                    </thead>
                    <tbody>
                      {conData && conData.length > 0 ? (
                        conData.map((item, i) => (
                          <tr key={i} style={{ textAlign: "right" }}>
                            <td style={{ textAlign: "right" }}>{i + 1}</td>
                            <td style={{ textAlign: "right" }}>{item.month_name}</td>
                            <td style={{ textAlign: "right" }}>{item.year}</td>
                            <td style={{ textAlign: "right" }}>{item.payment_type}</td>
                            <td>{item.os_basic_pay_earnings}</td>
                            <td>{item.os_ca_earnings}</td>
                            <td>{item.os_ec_epf}</td>
                            <td>{item.os_performance_earnings}</td>
                            <td>{item.os_hra_earnings}</td>
                            <td>{item.os_medical_earnings}</td>
                            <td>{item.os_ees_epf_deductions}</td>
                            <td>{item.os_ers_epf_deductions}</td>
                            <td>{item.os_prof_tax_deductions}</td>
                            <td>{item.os_other_deductions}</td>
                            <td style={{ color: "red" }}>{item.total_deductions}</td>
                            <td style={{ color: "green" }}>{item.total_earnings}</td>
                            <td style={{ color: "darkblue" }}>{item.total_earnings - item.total_deductions}</td>
                            {/* <td> <div style={{ textAlign: 'center' }}> <FaEye onClick={() => generateConsultantPayslip(item, formik.values.emp_id, displayempname, displayEmpType,
                              displayDistrict, 
                              designation)} /> </div> </td> */}
                            {/* <td> <div style={{ textAlign: 'center' }}> <FaEye onClick={() => generateConsultantPayslip(item, formik.values.emp_id, displayempname, displayEmpType, designation)} /> </div> </td> */}


                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="17">No data available</td>
                        </tr>
                      )}
                    </tbody>
                    <tfoot>
                      <tr style={{ textAlign: "right" }}>
                        <td colSpan="4" className="text-end fw-bold">Total</td>
                        <td>{conData.reduce((sum, item) => sum + item.os_basic_pay_earnings, 0)}</td>
                        <td>{conData.reduce((sum, item) => sum + item.os_ca_earnings, 0)}</td>
                        <td>{conData.reduce((sum, item) => sum + item.os_ec_epf, 0)}</td>
                        <td>{conData.reduce((sum, item) => sum + item.os_performance_earnings, 0)}</td>
                        <td>{conData.reduce((sum, item) => sum + item.os_hra_earnings, 0)}</td>
                        <td>{conData.reduce((sum, item) => sum + item.os_medical_earnings, 0)}</td>
                        <td>{conData.reduce((sum, item) => sum + item.os_ees_epf_deductions, 0)}</td>
                        <td>{conData.reduce((sum, item) => sum + item.os_ers_epf_deductions, 0)}</td>
                        <td>{conData.reduce((sum, item) => sum + item.os_prof_tax_deductions, 0)}</td>
                        <td>{conData.reduce((sum, item) => sum + item.os_other_deductions, 0)}</td>
                        <td style={{ color: "red" }}>{conData.reduce((sum, item) => sum + item.total_deductions, 0)}</td>
                        <td style={{ color: "green" }}>{conData.reduce((sum, item) => sum + item.total_earnings, 0)}</td>
                        <td style={{ color: "darkblue" }}>{conData.reduce((sum, item) => sum + (item.total_earnings - item.total_deductions), 0)}</td>
                        <td></td>

                      </tr>
                    </tfoot>
                  </OFMSUI.Table>
                </>)}
                {regDataTable && (<>
                  <div style={{ overflowX: 'auto' }}>
                    <OFMSUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className=' mb-2 float-end' >
                      <button type='button' className='btn btn-success btn-sm' style={{ float: 'right', color: '#fff' }} >
                        <ReactHTMLTableToExcel
                          id='test-table-xls-button'
                          className='download-table-xls-button'
                          table='my-table3'
                          filename='EmployeePay'
                          sheet='tablexls'
                          buttonText='Excel'
                        ></ReactHTMLTableToExcel>
                      </button>
                      {/* <button type='button' className='btn btn-danger btn-sm' onClick={() => GenerateOnclickPDF('my-table3')} style={{ float: 'right', marginLeft: '3px' }} > PDF <MdOutlinePictureAsPdf /> </button> */}
                    </OFMSUI.Col>
                  </div>
                  <center><h6 style={{ color: "red" }}>Employee Type : Regular</h6></center>
                  <OFMSUI.Table striped bordered hover id='my-table3'>
                    <thead className='fw-bold' style={{ position: 'sticky', top: '0px' }} >
                      <tr>
                        <th>S No.</th>
                        <th>Month</th>
                        <th>Year</th>
                        <th>Payment Type</th>
                        {regData && regData.some(item => item.basic_pay_earnings !== 0) && (<th>Basic Pay Earnings</th>)}
                        {regData && regData.some(item => item.ca_earnings !== 0) && (<th>CA Earnings</th>)}
                        {regData && regData.some(item => item.cca_earnings !== 0) && (<th>CCA Earnings</th>)}
                        {regData && regData.some(item => item.da_earnings !== 0) && (<th>DA Earnings</th>)}
                        {regData && regData.some(item => item.gp_earnings !== 0) && (<th>GP Earnings</th>)}
                        {regData && regData.some(item => item.hra_earnings !== 0) && (<th>HRA Earnings</th>)}
                        {regData && regData.some(item => item.ir_earnings !== 0) && (<th>IR Earnings</th>)}
                        {regData && regData.some(item => item.medical_earnings !== 0) && (<th>Medical Earnings</th>)}
                        {regData && regData.some(item => item.per_pay_earnings !== 0) && (<th>Per pay Earnings</th>)}
                        {regData && regData.some(item => item.spl_pay_earnings !== 0) && (<th>Spl Earnings</th>)}
                        {regData && regData.some(item => item.sca !== 0) && (<th>Sc Earnings</th>)}
                        {regData && regData.some(item => item.spl_all !== 0) && (<th>Spl all Earnings</th>)}
                        {regData && regData.some(item => item.misc_h_c !== 0) && (<th>Misc HC</th>)}
                        {regData && regData.some(item => item.addl_hra !== 0) && (<th>Additional HRA</th>)}

                        {regData && regData.some(item => item.total_earnings !== 0) && (<th style={{ color: "green" }}>Total Earnings</th>)}


                        {regData && regData.some(item => item.apglil_deductions !== 0) && (<th>Apglil deductions</th>)}
                        {regData && regData.some(item => item.apglis_deductions !== 0) && (<th>Apglis deductions</th>)}
                        {regData && regData.some(item => item.cca_deductions !== 0) && (<th>Cca deductions</th>)}
                        {regData && regData.some(item => item.cmrf_deductions !== 0) && (<th>Cmrf deductions</th>)}
                        {regData && regData.some(item => item.con_decd_deductions !== 0) && (<th>Con decd deductions</th>)}
                        {regData && regData.some(item => item.epf_deductions !== 0) && (<th>Epf deductions</th>)}
                        {regData && regData.some(item => item.epf_l_deductions !== 0) && (<th>Epf l deductions</th>)}
                        {regData && regData.some(item => item.fcf_deductions !== 0) && (<th>Fcf deductions</th>)}
                        {regData && regData.some(item => item.gis_deductions !== 0) && (<th>Gis deductions</th>)}
                        {regData && regData.some(item => item.gpfl_deductions !== 0) && (<th>Gpfl deductions</th>)}
                        {regData && regData.some(item => item.gpfs_deductions !== 0) && (<th>Gpfs deductions</th>)}
                        {regData && regData.some(item => item.gpfsa_deductions !== 0) && (<th>Gpfsa deductions</th>)}
                        {regData && regData.some(item => item.ppf_deductions !== 0) && (<th>Ppf deductions</th>)}
                        {regData && regData.some(item => item.vpf_deductions !== 0) && (<th>Vpf deductions</th>)}
                        {regData && regData.some(item => item.pt_deductions !== 0) && (<th>Pt deductions</th>)}
                        {regData && regData.some(item => item.it_deductions !== 0) && (<th>It deductions</th>)}
                        {regData && regData.some(item => item.lic_deductions !== 0) && (<th>LIC deductions</th>)}
                        {regData && regData.some(item => item.rcs_cont_deductions !== 0) && (<th>Rcs cont deductions</th>)}
                        {regData && regData.some(item => item.other_deductions !== 0) && (<th>Other deductions</th>)}

                        {regData && regData.some(item => item.house_rent_deductions !== 0) && (<th>House rent deductions</th>)}
                        {regData && regData.some(item => item.license_deductions !== 0) && (<th>License deductions</th>)}
                        {regData && regData.some(item => item.sal_rec_deductions !== 0) && (<th>Sal rec deductions</th>)}

                        {regData && regData.some(item => item.total_deductions !== 0) && (<th style={{ color: "red" }}>Total deductions</th>)}



                        {regData && regData.some(i => i.add_hba_loan !== 0) && <th>Add HBA Loan</th>}
                        {regData && regData.some(i => i.add_hba1_loan !== 0) && <th>Add HBA1 Loan</th>}
                        {regData && regData.some(i => i.car_i_loan !== 0) && <th>Car I Loan</th>}
                        {regData && regData.some(i => i.car_a_loan !== 0) && <th>Car A Loan</th>}
                        {regData && regData.some(i => i.cyc_i_loan !== 0) && <th>Cyc I Loan</th>}
                        {regData && regData.some(i => i.cyc_a_loan !== 0) && <th>Cyc A Loan</th>}
                        {regData && regData.some(i => i.mca_i_loan !== 0) && <th>MCA I Loan</th>}
                        {regData && regData.some(i => i.mca_a_loan !== 0) && <th>MCA A Loan</th>}
                        {regData && regData.some(i => i.mar_a_loan !== 0) && <th>MAR A Loan</th>}
                        {regData && regData.some(i => i.med_a_loan !== 0) && <th>Med A Loan</th>}
                        {regData && regData.some(i => i.hba_loan !== 0) && <th>HBA Loan</th>}
                        {regData && regData.some(i => i.hba1_loan !== 0) && <th>HBA1 Loan</th>}
                        {regData && regData.some(i => i.comp_loan !== 0) && <th>Comp Loan</th>}
                        {regData && regData.some(i => i.fa_loan !== 0) && <th>FA Loan</th>}
                        {regData && regData.some(i => i.ea_loan !== 0) && <th>EA Loan</th>}
                        {regData && regData.some(i => i.cell_loan !== 0) && <th>Cell Loan</th>}
                        {regData && regData.some(i => i.sal_adv_loan !== 0) && <th>Salary Adv Loan</th>}
                        {regData && regData.some(i => i.sfa_loan !== 0) && <th>SFA Loan</th>}
                        {regData && regData.some(i => i.med_a_i_loan !== 0) && <th>Med A I Loan</th>}
                        {regData && regData.some(i => i.hcesa_loan !== 0) && <th>HCESA Loan</th>}
                        {regData && regData.some(i => i.hcesa_i_loan !== 0) && <th>HCESA I Loan</th>}
                        {regData && regData.some(i => i.staff_pl_loan !== 0) && <th>Staff PL Loan</th>}
                        {regData && regData.some(i => i.court_loan !== 0) && <th>Court Loan</th>}
                        {regData && regData.some(i => i.vij_bank_loan !== 0) && <th>Bank Loan</th>}
                        {regData && regData.some(i => i.mar_i_loan !== 0) && <th>MAR I Loan</th>}
                        {regData && regData.some(i => i.hr_arrear_loan !== 0) && <th>HR Arrear Loan</th>}
                        {regData && regData.some(i => i.hbao_loan !== 0) && <th>HBAO Loan</th>}
                        {regData && regData.some(i => i.comp1_loan !== 0) && <th>Comp1 Loan</th>}

                        {/* PI Loans */}
                        {regData && regData.some(i => i.car_i_loanpi !== 0) && <th>Car I Loan PI</th>}
                        {regData && regData.some(i => i.car_a_loanpi !== 0) && <th>Car A Loan PI</th>}
                        {regData && regData.some(i => i.cyc_i_loanpi !== 0) && <th>Cyc I Loan PI</th>}
                        {regData && regData.some(i => i.cyc_a_loanpi !== 0) && <th>Cyc A Loan PI</th>}
                        {regData && regData.some(i => i.mca_i_loanpi !== 0) && <th>MCA I Loan PI</th>}
                        {regData && regData.some(i => i.mca_a_loanpi !== 0) && <th>MCA A Loan PI</th>}
                        {regData && regData.some(i => i.mar_a_loanpi !== 0) && <th>MAR A Loan PI</th>}
                        {regData && regData.some(i => i.med_a_loanpi !== 0) && <th>Med A Loan PI</th>}
                        {regData && regData.some(i => i.hba_loanpi !== 0) && <th>HBA Loan PI</th>}
                        {regData && regData.some(i => i.hba1_loanpi !== 0) && <th>HBA1 Loan PI</th>}
                        {regData && regData.some(i => i.comp_loanpi !== 0) && <th>Comp Loan PI</th>}
                        {regData && regData.some(i => i.fa_loanpi !== 0) && <th>FA Loan PI</th>}
                        {regData && regData.some(i => i.ea_loanpi !== 0) && <th>EA Loan PI</th>}
                        {regData && regData.some(i => i.cell_loanpi !== 0) && <th>Cell Loan PI</th>}
                        {regData && regData.some(i => i.add_hba_loanpi !== 0) && <th>Add HBA Loan PI</th>}
                        {regData && regData.some(i => i.add_hba1_loanpi !== 0) && <th>Add HBA1 Loan PI</th>}
                        {regData && regData.some(i => i.sal_adv_loanpi !== 0) && <th>Salary Adv Loan PI</th>}
                        {regData && regData.some(i => i.sfa_loanpi !== 0) && <th>SFA Loan PI</th>}
                        {regData && regData.some(i => i.med_a_i_loanpi !== 0) && <th>Med A I Loan PI</th>}
                        {regData && regData.some(i => i.hcesa_loanpi !== 0) && <th>HCESA Loan PI</th>}
                        {regData && regData.some(i => i.hcesa_i_loanpi !== 0) && <th>HCESA I Loan PI</th>}
                        {regData && regData.some(i => i.staff_pl_loanpi !== 0) && <th>Staff PL Loan PI</th>}
                        {regData && regData.some(i => i.court_loanpi !== 0) && <th>Court Loan PI</th>}
                        {regData && regData.some(i => i.vij_bank_loanpi !== 0) && <th>Bank Loan PI</th>}
                        {regData && regData.some(i => i.mar_i_loanpi !== 0) && <th>MAR I Loan PI</th>}
                        {regData && regData.some(i => i.hr_arrear_loanpi !== 0) && <th>HR Arrear Loan PI</th>}
                        {regData && regData.some(i => i.hbao_loanpi !== 0) && <th>HBAO Loan PI</th>}
                        {regData && regData.some(i => i.comp1_loanpi !== 0) && <th>Comp1 Loan PI</th>}

                        {/* TI Loans */}
                        {regData && regData.some(i => i.car_i_loanti !== 0) && <th>Car I Loan TI</th>}
                        {regData && regData.some(i => i.car_a_loanti !== 0) && <th>Car A Loan TI</th>}
                        {regData && regData.some(i => i.cyc_i_loanti !== 0) && <th>Cyc I Loan TI</th>}
                        {regData && regData.some(i => i.cyc_a_loanti !== 0) && <th>Cyc A Loan TI</th>}
                        {regData && regData.some(i => i.mca_i_loanti !== 0) && <th>MCA I Loan TI</th>}
                        {regData && regData.some(i => i.mca_a_loanti !== 0) && <th>MCA A Loan TI</th>}
                        {regData && regData.some(i => i.mar_a_loanti !== 0) && <th>MAR A Loan TI</th>}
                        {regData && regData.some(i => i.med_a_loanti !== 0) && <th>Med A Loan TI</th>}
                        {regData && regData.some(i => i.hba_loanti !== 0) && <th>HBA Loan TI</th>}
                        {regData && regData.some(i => i.hba1_loanti !== 0) && <th>HBA1 Loan TI</th>}
                        {regData && regData.some(i => i.comp_loanti !== 0) && <th>Comp Loan TI</th>}
                        {regData && regData.some(i => i.fa_loanti !== 0) && <th>FA Loan TI</th>}
                        {regData && regData.some(i => i.ea_loanti !== 0) && <th>EA Loan TI</th>}
                        {regData && regData.some(i => i.cell_loanti !== 0) && <th>Cell Loan TI</th>}
                        {regData && regData.some(i => i.add_hba_loanti !== 0) && <th>Add HBA Loan TI</th>}
                        {regData && regData.some(i => i.add_hba1_loanti !== 0) && <th>Add HBA1 Loan TI</th>}
                        {regData && regData.some(i => i.sal_adv_loanti !== 0) && <th>Salary Adv Loan TI</th>}
                        {regData && regData.some(i => i.sfa_loanti !== 0) && <th>SFA Loan TI</th>}
                        {regData && regData.some(i => i.med_a_i_loanti !== 0) && <th>Med A I Loan TI</th>}
                        {regData && regData.some(i => i.hcesa_loanti !== 0) && <th>HCESA Loan TI</th>}
                        {regData && regData.some(i => i.hcesa_i_loanti !== 0) && <th>HCESA I Loan TI</th>}
                        {regData && regData.some(i => i.staff_pl_loanti !== 0) && <th>Staff PL Loan TI</th>}
                        {regData && regData.some(i => i.court_loanti !== 0) && <th>Court Loan TI</th>}
                        {regData && regData.some(i => i.vij_bank_loanti !== 0) && <th>Bank Loan TI</th>}
                        {regData && regData.some(i => i.mar_i_loanti !== 0) && <th>MAR I Loan TI</th>}
                        {regData && regData.some(i => i.hr_arrear_loanti !== 0) && <th>HR Arrear Loan TI</th>}
                        {regData && regData.some(i => i.hbao_loanti !== 0) && <th>HBAO Loan TI</th>}
                        {regData && regData.some(i => i.comp1_loanti !== 0) && <th>Comp1 Loan TI</th>}
                        {regData && regData.some(i => i.total_loan !== 0) && <th style={{ color: "red" }}>Total Loan</th>}

                        <th>Net Salary</th>
                        {/* <th>View Pay Slip</th> */}


                      </tr>
                    </thead>
                    <tbody>
                      {regData &&
                        regData.length > 0 ? (
                        regData.map((item, i) => (
                          <tr key={i}>
                            <td className="text-end">{i + 1}</td>
                            <td>{item.month_name}</td>
                            <td>{item.year}</td>
                            <td>{item.payment_type}</td>

                            {regData && regData.some(item => item.basic_pay_earnings !== 0) && (<td>{item.basic_pay_earnings}</td>)}
                            {regData && regData.some(item => item.ca_earnings !== 0) && (<td>{item.ca_earnings}</td>)}
                            {regData && regData.some(item => item.cca_earnings !== 0) && (<td>{item.cca_earnings}</td>)}
                            {regData && regData.some(item => item.da_earnings !== 0) && (<td>{item.da_earnings}</td>)}
                            {regData && regData.some(item => item.gp_earnings !== 0) && (<td>{item.gp_earnings}</td>)}
                            {regData && regData.some(item => item.hra_earnings !== 0) && (<td>{item.hra_earnings}</td>)}
                            {regData && regData.some(item => item.ir_earnings !== 0) && (<td>{item.ir_earnings}</td>)}
                            {regData && regData.some(item => item.medical_earnings !== 0) && (<td>{item.medical_earnings}</td>)}
                            {regData && regData.some(item => item.per_pay_earnings !== 0) && (<td>{item.per_pay_earnings}</td>)}
                            {regData && regData.some(item => item.spl_pay_earnings !== 0) && (<td>{item.spl_pay_earnings}</td>)}
                            {regData && regData.some(item => item.sca !== 0) && (<td>{item.sca}</td>)}
                            {regData && regData.some(item => item.spl_all !== 0) && (<td>{item.spl_all}</td>)}
                            {regData && regData.some(item => item.misc_h_c !== 0) && (<td>{item.misc_h_c}</td>)}
                            {regData && regData.some(item => item.addl_hra !== 0) && (<td>{item.addl_hra}</td>)}

                            {regData && regData.some(item => item.total_earnings !== 0) && (<td style={{ color: "green" }}>{item.total_earnings}</td>)}

                            {regData && regData.some(item => item.apglil_deductions !== 0) && (<td>{item.apglil_deductions}</td>)}
                            {regData && regData.some(item => item.apglis_deductions !== 0) && (<td>{item.apglis_deductions}</td>)}
                            {regData && regData.some(item => item.cca_deductions !== 0) && (<td>{item.cca_deductions}</td>)}
                            {regData && regData.some(item => item.cmrf_deductions !== 0) && (<td>{item.cmrf_deductions}</td>)}
                            {regData && regData.some(item => item.con_decd_deductions !== 0) && (<td>{item.con_decd_deductions}</td>)}
                            {regData && regData.some(item => item.epf_deductions !== 0) && (<td>{item.epf_deductions}</td>)}
                            {regData && regData.some(item => item.epf_l_deductions !== 0) && (<td>{item.epf_l_deductions}</td>)}
                            {regData && regData.some(item => item.fcf_deductions !== 0) && (<td>{item.fcf_deductions}</td>)}
                            {regData && regData.some(item => item.gis_deductions !== 0) && (<td>{item.gis_deductions}</td>)}
                            {regData && regData.some(item => item.gpfl_deductions !== 0) && (<td>{item.gpfl_deductions}</td>)}
                            {regData && regData.some(item => item.gpfs_deductions !== 0) && (<td>{item.gpfs_deductions}</td>)}
                            {regData && regData.some(item => item.gpfsa_deductions !== 0) && (<td>{item.gpfsa_deductions}</td>)}
                            {regData && regData.some(item => item.ppf_deductions !== 0) && (<td>{item.ppf_deductions}</td>)}
                            {regData && regData.some(item => item.vpf_deductions !== 0) && (<td>{item.vpf_deductions}</td>)}
                            {regData && regData.some(item => item.pt_deductions !== 0) && (<td>{item.pt_deductions}</td>)}
                            {regData && regData.some(item => item.it_deductions !== 0) && (<td>{item.it_deductions}</td>)}
                            {regData && regData.some(item => item.lic_deductions !== 0) && (<td>{item.lic_deductions}</td>)}
                            {regData && regData.some(item => item.rcs_cont_deductions !== 0) && (<td>{item.rcs_cont_deductions}</td>)}
                            {regData && regData.some(item => item.other_deductions !== 0) && (<td>{item.other_deductions}</td>)}
                            {regData && regData.some(item => item.house_rent_deductions !== 0) && (<td>{item.house_rent_deductions}</td>)}
                            {regData && regData.some(item => item.license_deductions !== 0) && (<td>{item.license_deductions}</td>)}
                            {regData && regData.some(item => item.sal_rec_deductions !== 0) && (<td>{item.sal_rec_deductions}</td>)}

                            {regData && regData.some(item => item.total_deductions !== 0) && (<td style={{ color: "red" }}>{item.total_deductions}</td>)}

                            {regData && regData.some(i => i.add_hba_loan !== 0) && (<td>{item.add_hba_loan}</td>)}
                            {regData && regData.some(i => i.add_hba1_loan !== 0) && (<td>{item.add_hba1_loan}</td>)}
                            {regData && regData.some(i => i.car_i_loan !== 0) && (<td>{item.car_i_loan}</td>)}
                            {regData && regData.some(i => i.car_a_loan !== 0) && (<td>{item.car_a_loan}</td>)}
                            {regData && regData.some(i => i.cyc_i_loan !== 0) && (<td>{item.cyc_i_loan}</td>)}
                            {regData && regData.some(i => i.cyc_a_loan !== 0) && (<td>{item.cyc_a_loan}</td>)}
                            {regData && regData.some(i => i.mca_i_loan !== 0) && (<td>{item.mca_i_loan}</td>)}
                            {regData && regData.some(i => i.mca_a_loan !== 0) && (<td>{item.mca_a_loan}</td>)}
                            {regData && regData.some(i => i.mar_a_loan !== 0) && (<td>{item.mar_a_loan}</td>)}
                            {regData && regData.some(i => i.med_a_loan !== 0) && (<td>{item.med_a_loan}</td>)}
                            {regData && regData.some(i => i.hba_loan !== 0) && (<td>{item.hba_loan}</td>)}
                            {regData && regData.some(i => i.hba1_loan !== 0) && (<td>{item.hba1_loan}</td>)}
                            {regData && regData.some(i => i.comp_loan !== 0) && (<td>{item.comp_loan}</td>)}
                            {regData && regData.some(i => i.fa_loan !== 0) && (<td>{item.fa_loan}</td>)}
                            {regData && regData.some(i => i.ea_loan !== 0) && (<td>{item.ea_loan}</td>)}
                            {regData && regData.some(i => i.cell_loan !== 0) && (<td>{item.cell_loan}</td>)}
                            {regData && regData.some(i => i.sal_adv_loan !== 0) && (<td>{item.sal_adv_loan}</td>)}
                            {regData && regData.some(i => i.sfa_loan !== 0) && (<td>{item.sfa_loan}</td>)}
                            {regData && regData.some(i => i.med_a_i_loan !== 0) && (<td>{item.med_a_i_loan}</td>)}
                            {regData && regData.some(i => i.hcesa_loan !== 0) && (<td>{item.hcesa_loan}</td>)}
                            {regData && regData.some(i => i.hcesa_i_loan !== 0) && (<td>{item.hcesa_i_loan}</td>)}
                            {regData && regData.some(i => i.staff_pl_loan !== 0) && (<td>{item.staff_pl_loan}</td>)}
                            {regData && regData.some(i => i.court_loan !== 0) && (<td>{item.court_loan}</td>)}
                            {regData && regData.some(i => i.vij_bank_loan !== 0) && (<td>{item.vij_bank_loan}</td>)}
                            {regData && regData.some(i => i.mar_i_loan !== 0) && (<td>{item.mar_i_loan}</td>)}
                            {regData && regData.some(i => i.hr_arrear_loan !== 0) && (<td>{item.hr_arrear_loan}</td>)}
                            {regData && regData.some(i => i.hbao_loan !== 0) && (<td>{item.hbao_loan}</td>)}
                            {regData && regData.some(i => i.comp1_loan !== 0) && (<td>{item.comp1_loan}</td>)}


                            {/* PI Loans */}
                            {regData && regData.some(i => i.car_i_loanpi !== 0) && (<td>{item.car_i_loanpi}</td>)}
                            {regData && regData.some(i => i.car_a_loanpi !== 0) && (<td>{item.car_a_loanpi}</td>)}
                            {regData && regData.some(i => i.cyc_i_loanpi !== 0) && (<td>{item.cyc_i_loanpi}</td>)}
                            {regData && regData.some(i => i.cyc_a_loanpi !== 0) && (<td>{item.cyc_a_loanpi}</td>)}
                            {regData && regData.some(i => i.mca_i_loanpi !== 0) && (<td>{item.mca_i_loanpi}</td>)}
                            {regData && regData.some(i => i.mca_a_loanpi !== 0) && (<td>{item.mca_a_loanpi}</td>)}
                            {regData && regData.some(i => i.mar_a_loanpi !== 0) && (<td>{item.mar_a_loanpi}</td>)}
                            {regData && regData.some(i => i.med_a_loanpi !== 0) && (<td>{item.med_a_loanpi}</td>)}
                            {regData && regData.some(i => i.hba_loanpi !== 0) && (<td>{item.hba_loanpi}</td>)}
                            {regData && regData.some(i => i.hba1_loanpi !== 0) && (<td>{item.hba1_loanpi}</td>)}
                            {regData && regData.some(i => i.comp_loanpi !== 0) && (<td>{item.comp_loanpi}</td>)}
                            {regData && regData.some(i => i.fa_loanpi !== 0) && (<td>{item.fa_loanpi}</td>)}
                            {regData && regData.some(i => i.ea_loanpi !== 0) && (<td>{item.ea_loanpi}</td>)}
                            {regData && regData.some(i => i.cell_loanpi !== 0) && (<td>{item.cell_loanpi}</td>)}
                            {regData && regData.some(i => i.add_hba_loanpi !== 0) && (<td>{item.add_hba_loanpi}</td>)}
                            {regData && regData.some(i => i.add_hba1_loanpi !== 0) && (<td>{item.add_hba1_loanpi}</td>)}
                            {regData && regData.some(i => i.sal_adv_loanpi !== 0) && (<td>{item.sal_adv_loanpi}</td>)}
                            {regData && regData.some(i => i.sfa_loanpi !== 0) && (<td>{item.sfa_loanpi}</td>)}
                            {regData && regData.some(i => i.med_a_i_loanpi !== 0) && (<td>{item.med_a_i_loanpi}</td>)}
                            {regData && regData.some(i => i.hcesa_loanpi !== 0) && (<td>{item.hcesa_loanpi}</td>)}
                            {regData && regData.some(i => i.hcesa_i_loanpi !== 0) && (<td>{item.hcesa_i_loanpi}</td>)}
                            {regData && regData.some(i => i.staff_pl_loanpi !== 0) && (<td>{item.staff_pl_loanpi}</td>)}
                            {regData && regData.some(i => i.court_loanpi !== 0) && (<td>{item.court_loanpi}</td>)}
                            {regData && regData.some(i => i.vij_bank_loanpi !== 0) && (<td>{item.vij_bank_loanpi}</td>)}
                            {regData && regData.some(i => i.mar_i_loanpi !== 0) && (<td>{item.mar_i_loanpi}</td>)}
                            {regData && regData.some(i => i.hr_arrear_loanpi !== 0) && (<td>{item.hr_arrear_loanpi}</td>)}
                            {regData && regData.some(i => i.hbao_loanpi !== 0) && (<td>{item.hbao_loanpi}</td>)}
                            {regData && regData.some(i => i.comp1_loanpi !== 0) && (<td>{item.comp1_loanpi}</td>)}


                            {/* TI Loans */}
                            {regData && regData.some(i => i.car_i_loanti !== 0) && (<td>{item.car_i_loanti}</td>)}
                            {regData && regData.some(i => i.car_a_loanti !== 0) && (<td>{item.car_a_loanti}</td>)}
                            {regData && regData.some(i => i.cyc_i_loanti !== 0) && (<td>{item.cyc_i_loanti}</td>)}
                            {regData && regData.some(i => i.cyc_a_loanti !== 0) && (<td>{item.cyc_a_loanti}</td>)}
                            {regData && regData.some(i => i.mca_i_loanti !== 0) && (<td>{item.mca_i_loanti}</td>)}
                            {regData && regData.some(i => i.mca_a_loanti !== 0) && (<td>{item.mca_a_loanti}</td>)}
                            {regData && regData.some(i => i.mar_a_loanti !== 0) && (<td>{item.mar_a_loanti}</td>)}
                            {regData && regData.some(i => i.med_a_loanti !== 0) && (<td>{item.med_a_loanti}</td>)}
                            {regData && regData.some(i => i.hba_loanti !== 0) && (<td>{item.hba_loanti}</td>)}
                            {regData && regData.some(i => i.hba1_loanti !== 0) && (<td>{item.hba1_loanti}</td>)}
                            {regData && regData.some(i => i.comp_loanti !== 0) && (<td>{item.comp_loanti}</td>)}
                            {regData && regData.some(i => i.fa_loanti !== 0) && (<td>{item.fa_loanti}</td>)}
                            {regData && regData.some(i => i.ea_loanti !== 0) && (<td>{item.ea_loanti}</td>)}
                            {regData && regData.some(i => i.cell_loanti !== 0) && (<td>{item.cell_loanti}</td>)}
                            {regData && regData.some(i => i.add_hba_loanti !== 0) && (<td>{item.add_hba_loanti}</td>)}
                            {regData && regData.some(i => i.add_hba1_loanti !== 0) && (<td>{item.add_hba1_loanti}</td>)}
                            {regData && regData.some(i => i.sal_adv_loanti !== 0) && (<td>{item.sal_adv_loanti}</td>)}
                            {regData && regData.some(i => i.sfa_loanti !== 0) && (<td>{item.sfa_loanti}</td>)}
                            {regData && regData.some(i => i.med_a_i_loanti !== 0) && (<td>{item.med_a_i_loanti}</td>)}
                            {regData && regData.some(i => i.hcesa_loanti !== 0) && (<td>{item.hcesa_loanti}</td>)}
                            {regData && regData.some(i => i.hcesa_i_loanti !== 0) && (<td>{item.hcesa_i_loanti}</td>)}
                            {regData && regData.some(i => i.staff_pl_loanti !== 0) && (<td>{item.staff_pl_loanti}</td>)}
                            {regData && regData.some(i => i.court_loanti !== 0) && (<td>{item.court_loanti}</td>)}
                            {regData && regData.some(i => i.vij_bank_loanti !== 0) && (<td>{item.vij_bank_loanti}</td>)}
                            {regData && regData.some(i => i.mar_i_loanti !== 0) && (<td>{item.mar_i_loanti}</td>)}
                            {regData && regData.some(i => i.hr_arrear_loanti !== 0) && (<td>{item.hr_arrear_loanti}</td>)}
                            {regData && regData.some(i => i.hbao_loanti !== 0) && (<td>{item.hbao_loanti}</td>)}
                            {regData && regData.some(i => i.comp1_loanti !== 0) && (<td>{item.comp1_loanti}</td>)}

                            {regData && regData.some(i => i.total_loan !== 0) && (<td style={{ color: "red" }}>{item.total_loan}</td>)}


                            <td style={{ color: "darkblue" }}> {parseInt(item.total_earnings - (item.total_deductions + item.total_loan))} </td>
                            {/* <td> <div style={{ textAlign: 'center' }}> <FaEye onClick={() => generateRegularPayslip(item, displayempname, displayEmpType,
                              displayDistrict,
                              designation)} />
                            </div> </td> */}

                            {/* <td> <div style={{ textAlign: 'center' }}> <FaEye
                              onClick={() => generateRegularPayslip(item, displayempname, displayEmpType, designation)} />
                            </div> </td> */}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan='6' style={{ textAlign: 'center' }}>
                            No data found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </OFMSUI.Table>
                </>)}


                <button type='button' className='btn btn-primary btn-sm' onClick={handleClose} style={{ alignItems: 'center' }} > Close </button>
              </div>
            )}
          </FormikProvider>
        </OFMSUI.Container>
      </>
    </>
  )
}
export default EmployeePayParticulars

